import Vue from "vue";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faSpinnerThird } from "@fortawesome/pro-duotone-svg-icons";
import {
  faLink,
  faQuestionCircle,
  faCheck,
  faChevronLeft,
  faClone,
  faEdit,
  faEllipsisV,
  faExchange,
  faFileDownload,
  faGripVertical,
  faPlus,
  faSignOut,
  faSort,
  faChevronCircleDown,
  faTimes,
  faTrash,
  faChevronCircleUp,
  faUser,
  faKey,
  faSignIn,
  faFilter,
  faFileExport,
  faDownload,
  faThumbsUp,
} from "@fortawesome/pro-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faSpinnerThird,
  faEdit,
  faClone,
  faFileDownload,
  faTrash,
  faExchange,
  faEllipsisV,
  faTimes,
  faSignOut,
  faCheck,
  faChevronLeft,
  faPlus,
  faSort,
  faGripVertical,
  faChevronCircleDown,
  faChevronCircleUp,
  faUser,
  faKey,
  faSignIn,
  faQuestionCircle,
  faFilter,
  faLink,
  faFileExport,
  faDownload,
  faThumbsUp
);

Vue.component("fa-icon", FontAwesomeIcon);
